import React from 'react';
import './styles.css';

const DevTopbar = () => <div className="dev-topbar" />;

export default DevTopbar;
